import { render, staticRenderFns } from "./freightMaintain.vue?vue&type=template&id=0072dc12&scoped=true&"
import script from "./freightMaintain.vue?vue&type=script&lang=js&"
export * from "./freightMaintain.vue?vue&type=script&lang=js&"
import style0 from "./freightMaintain.vue?vue&type=style&index=0&id=0072dc12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072dc12",
  null
  
)

export default component.exports